import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LogoComponent } from '@core/ui-kit/components';
import { environment } from '@environments/environment';
import { TranslocoPipe } from '@jsverse/transloco';

import { AuthStore, Role, TRole } from '../../data-access/data-access-authentication';
import { UiStore } from '../../data-access/data-access-ui';
import { RoleDirective } from '../../directives/role.directive';
import { BurgerMenuComponent } from './burger-menu/burger-menu.component';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';
import { UserMembershipRecapComponent } from './user-membership-recap/user-membership-recap.component';
import { WelcomeBannerComponent } from './welcome-banner/welcome-banner.component';

@Component({
  selector: 'app-navbar',
  imports: [
    RoleDirective,
    TranslocoPipe,
    LogoComponent,
    RouterLink,
    RouterLinkActive,
    UserAvatarComponent,
    WelcomeBannerComponent,
    BurgerMenuComponent,
    UserMembershipRecapComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  private readonly authStore = inject(AuthStore);
  private readonly uiStore = inject(UiStore);

  private readonly isNavbarExpanded = this.uiStore.isNavbarExpanded;
  private readonly isAdmin = this.authStore.isAdmin;
  expanded = computed(() => this.isNavbarExpanded() && !this.isAdmin());
  user = this.authStore.data;
  firstName = this.authStore.firstName;
  isKnowledgeEnabled = environment.headlessCms.enabled;

  Role = Role;

  menu = signal<{ label: string; url: string; roles?: TRole[] }[]>([
    {
      label: 'navbar.menu.your-overview',
      url: '/dashboard',
    },
    {
      label: 'users.list.title',
      url: '/user',
      roles: [Role.ADMIN, Role.ANALYST],
    },
    {
      label: 'navbar.menu.new-search',
      url: '/search',
    },
    { label: 'navbar.menu.reports', url: '/report' },
    {
      label: 'navbar.menu.activity-log',
      url: '/activity-log',
    },
    {
      label: 'navbar.menu.bank-cards',
      url: '/bank-cards',
      roles: [Role.ADMIN],
    },
    ...(this.isKnowledgeEnabled
      ? [
          {
            label: 'navbar.menu.knowledge',
            url: '/knowledge',
          },
        ]
      : []),
    {
      label: 'navbar.menu.ai-knowledge',
      url: '/ai-knowledge',
      roles: [Role.ADMIN, Role.ANALYST],
    },
  ]);
  showMobileMenu = signal(false);

  toggleMobileMenu(): void {
    this.showMobileMenu.update((show) => !show);
  }

  logout(): void {
    this.authStore.logout();
  }
}
